import * as React from 'react';
import { getTargetReachStepConfig, getTargetReachStepProgress } from './targetReachStepUtils';

export interface ITargetReachProgressProps {
    currentStep: string;
}

const TargetReachProgress: React.FunctionComponent<ITargetReachProgressProps> = ({ currentStep }) => {
    const stepConfig = getTargetReachStepConfig(currentStep);
    const progress = getTargetReachStepProgress(currentStep);

    if (!stepConfig || !progress) {
        return null;
    }

    const styles = {
        container: {
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            backdropFilter: 'blur(8px)',
            borderRadius: '8px',
            padding: '12px 14px',
            marginBottom: '8px'
        },
        header: {
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            marginBottom: '8px'
        },
        spinner: {
            width: '14px',
            height: '14px',
            border: '2px solid rgba(255, 255, 255, 0.3)',
            borderTopColor: '#ffffff',
            borderRadius: '50%',
            animation: 'targetReachSpin 1s linear infinite'
        },
        stepLabel: {
            color: '#ffffff',
            fontSize: '13px',
            fontWeight: 600
        },
        progressBarContainer: {
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            borderRadius: '4px',
            height: '6px',
            overflow: 'hidden',
            marginBottom: '6px'
        },
        progressBarFill: {
            backgroundColor: '#8b5cf6',
            height: '100%',
            borderRadius: '4px',
            transition: 'width 0.3s ease',
            width: `${progress.percentage}%`
        },
        stepCount: {
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: '11px'
        }
    };

    return (
        <div style={styles.container}>
            <style>
                {`
                    @keyframes targetReachSpin {
                        to { transform: rotate(360deg); }
                    }
                `}
            </style>
            <div style={styles.header}>
                <div style={styles.spinner} />
                <span style={styles.stepLabel}>{stepConfig.label}</span>
            </div>
            <div style={styles.progressBarContainer}>
                <div style={styles.progressBarFill} />
            </div>
            <span style={styles.stepCount}>
                Step {progress.current} of {progress.total}
            </span>
        </div>
    );
};

export { TargetReachProgress };
